import Box from "@mui/material/Box/Box";
import React from "react";

interface GenieCardProps {
  children: React.ReactNode;
}

function GenieCard({ children }: GenieCardProps) {
  return (
    <Box
      mt={4}
      p={5}
      sx={{ borderColor: "grey.300" }}
      border={1}
      borderRadius={2}
    >
      {children}
    </Box>
  );
}

export default GenieCard;
